// extracted by mini-css-extract-plugin
export var progressBar = "_jr-0";
export var progressBarInner = "_jr-1";